import React, { FunctionComponent, useEffect, useState } from 'react'
import ForumQandAList from './ForumQandAList'
import SearchForm from './SearchForm'
import { IForumTag, ISelectOption } from 'Frontend/scripts/models/forums.model'
import { getForumTags } from 'Frontend/scripts/services/forums.service'
import { ForumQAndAProvider } from './forumQAndAContext'

interface ForumQandAProps {
  pageName: string | null
}

const ForumQandA: FunctionComponent<ForumQandAProps> = (props) => {
  const [tags, setTags] = useState<ISelectOption[]>([])
  const options = [] as ISelectOption[]

  useEffect(() => {
    getForumTags().then((data: IForumTag[]) => {
      options.length = 0
      data.map((tag) => {
        options.push({ value: tag.id.toString(), label: tag.name })
      })
      setTags(options)
    })
  }, [])

  return (
    <ForumQAndAProvider>
      <SearchForm {...props} tags={tags} />
      <ForumQandAList />
    </ForumQAndAProvider>
  )
}
export default ForumQandA
